export const teams = [
    {
        'teamID': 1,
        'teamName': 'Tiger Team',
        'teamColor': '#FF6358'
    },
    {
        'teamID': 2,
        'teamName': 'Lemon Team',
        'teamColor': '#F7C62F'
    },
    {
        'teamID': 3,
        'teamName': 'Organic Team',
        'teamColor': '#55AB1D'
    },
    {
        'teamID': 4,
        'teamName': 'Ocean Team',
        'teamColor': '#c828c8ff'
    }
];